import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class EmailButtonModel extends ButtonBase {
    label: string = 'Email';
    action: string = ACTION_STATUS.email;
    matIconName: string = 'attach_email';
    colorClass: string = 'color-secondary-500';
}